/** Show the form only after its EmailJS public key has been configured. */
export const CONTACT_FORM_ENABLED = Boolean(import.meta.env.VITE_EMAILJS_PUBLIC_KEY)
